import React, { useState } from 'react';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import SchoolAgreementModal from './SchoolAgreementModal';
import css from './SchoolPoweredFooter.module.css';

export default function SchoolPoweredFooter({ role = 'all' }) {
  const [agreementOpen, setAgreementOpen] = useState(false);
  const [agreementTab, setAgreementTab] = useState(role || 'all');

  const openAgreement = (tabKey) => {
    setAgreementTab(tabKey || role || 'all');
    setAgreementOpen(true);
  };

  return (
    <>
      <footer className={css.footer}>
        <span className={css.rule} />
        <span className={css.content}>
          <AutoAwesomeIcon className={css.icon} aria-hidden="true" />
          <span>Powered by <strong>Bubble Ai Schools</strong></span>
          <span className={css.year}>© {new Date().getFullYear()}</span>
          <span className={css.dot}>•</span>
          <button
            type="button"
            className={css.legalLink}
            onClick={() => openAgreement(role)}
            title="View Bubble Ai Schools Master User Agreement & Safeguarding Policy"
          >
            User Agreement & Terms
          </button>
          <span className={css.dot}>•</span>
          <button
            type="button"
            className={css.legalLink}
            onClick={() => openAgreement('privacy')}
            title="View NDPA 2023 Child Safeguarding & Privacy Safeguards"
          >
            NDPA Privacy
          </button>
        </span>
        <span className={css.rule} />
      </footer>

      <SchoolAgreementModal
        open={agreementOpen}
        initialRole={agreementTab}
        onClose={() => setAgreementOpen(false)}
      />
    </>
  );
}
